export default __webpack_public_path__ + "static/media/exp4.61923fb8.png";